import "./ReportInfoData.scss";
import { useSelector } from "react-redux";
import { Divider, Typography } from "@mui/material";
import { RootState } from "../../../store/reducers";
import { useTranslation } from "react-i18next";

export const ReportInfoData = () => {
  const { t } = useTranslation();
  const { publicationMarketDate, submissionOrgDate } = useSelector(
    (state: RootState) => state.jobPricingDetails
  );
  const { configList } = useSelector((state: RootState) => state.config);

  const hasClientPaySubmission =
    Number(configList?.[0]?.clientPaySubmissionKey) > 0;
  return (
    <div className="info-data-container">
      {publicationMarketDate && (
        <Typography variant="caption">
          {t("pa.publicationMarket")} : {publicationMarketDate}
        </Typography>
      )}
      {hasClientPaySubmission && submissionOrgDate && (
        <>
          <Typography variant="caption" sx={{ padding: "4px 0px !important" }}>
            <Divider orientation="vertical" variant="middle" />
          </Typography>
          <Typography variant="caption">
            {t("pa.submissionOrg")}: {submissionOrgDate}
          </Typography>
        </>
      )}
    </div>
  );
};
